<template>
    <nav>
        <div class='flex'>
            <button
                v-for='(tab, index) in tabs' :key='tab.title'
                @click.prevent="selectTab(index)"
                class="py-4 px-10 border hover:text-gray-800 focus:outline-none"
                :class="[index === selectedIndex ? 'bg-white text-gray-800 border-white' : 'bg-gray-100 text-gray-500 border-gray-200']"
            >
                {{tab.title}}
            </button>
        </div>
        <slot></slot>
     </nav>
</template>

<script>
export default {
    data() {
        return {
            selectedIndex: 0,
            tabs: []
        };
    },
    created() {
        this.tabs = this.$children;
    },
    mounted() {
        this.selectTab(0);
    },
    methods: {
        selectTab(i) {
            this.selectedIndex = i;
            this.tabs.forEach((tab, index) => {
                tab.isActive = (index === i);
            });
        }
    }
};
</script>
